import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { F1StrategyMetadataCard } from "./card";
import { F1StrategyMetadataNew } from "./new";
import { F1StrategyMetadataTable } from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

export default function F1StrategyMetadata() {
  useEffect(() => {
    setDocumentTitle("Quantilia | F1 Strategy Metadata");
  }, []);

  return (
    <Routes>
      <Route index element={<F1StrategyMetadataTable />} />
      <Route path="new" element={<F1StrategyMetadataNew />} />
      <Route path=":id" element={<F1StrategyMetadataCard />} />
    </Routes>
  );
}
